import styles from './dialogSection.module.scss'

import type {ComponentProps} from 'react'

type DialogStyledSectionProps = ComponentProps<'div'>

/**
 * This component is currently used for "visual backwards compatibility" with old dialogs:
 * - Cookie-Richtlinien
 * - Disclaimer
 */
export const DialogStyledSection = (props: DialogStyledSectionProps) => {
  const {className, ...restProps} = props
  return (
    <div
      className={`${className} ${styles.dialogHtml}`}
      {...restProps}
    />
  )
}
